<section
  class="covid-19 layout"
  fxLayout="column"
  fxLayoutAlign="center center"
  [ngClass.lt-sm]="{'xs sm':true}"
  [ngClass.lt-md]="{'sm':true}"
>
  <h2>当院では新型コロナウイルス対策を実施しています</h2>
  <ul class="icons" fxLayout="row wrap" fxLayoutAlign="center center">
    <li><img src="/assets/img/covid19_1.svg" alt="マスクの着用"></li>
    <li><img src="/assets/img/covid19_2.svg" alt="換気"></li>
    <li><img src="/assets/img/covid19_3.svg" alt="消毒"></li>
  </ul>
  <div>
    <p>当院では新型コロナウイルスの拡大防止のため、マスクの着用や、施設内の消毒などを実施しています。</p>
    <p>お客様の健康を守るためにも、ご理解・ご協力をお願い致します。</p>
  </div>
</section>
